import * as React from "react";
import Cookies from "universal-cookie";
import { useYbugApi } from "ybug-react";

const cookies = new Cookies();

export default function UserProvider(props) {
  // eslint-disable-next-line
  const [user, setUser] = React.useState(cookies.get("usercode"));
  const YbugContext = useYbugApi();
  React.useEffect(() => {
    if (YbugContext.Ybug) {
      if (user) {
        YbugContext.init({
          feedback: {
            email: user ? user.email : "",
            name: user ? user.fullName : "",
          },
          // user: {
          //   email: user ? user.email : "",
          //   name: user ? user.fullName : "",
          // },
          email: false,
          email_required: true,
        });
      }
      else {
        YbugContext.Ybug.hide("launcher");
    }
  } 
  });

  return props.children;
}
